module.exports = __webpack_public_path__ + "static/media/uob-icon-white-42x12.94cf8215.svg";